import { useTheme } from "@mui/material";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

export default function NavBar() {
  const theme = useTheme();
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "inherit",
          color: "inherit",
        }}
        elevation={1}
      >
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h5"
            component={Link}
            to="/"
            sx={{
              textDecoration: "none",
              color: "inherit",
              fontFamily: "'Pinyon Script', cursive",
              fontSize: "4rem",
              paddingTop: "1rem",
              "@media (max-width:600px)": {
                fontSize: "9vw",
              },
            }}
          >
            Adam & Tori's Wedding
          </Typography>
          <Box>
            <Button component={Link} to="/" color="inherit">
              Home
            </Button>
            <Button component={Link} to="/ourstory" color="inherit">
              Our Story
            </Button>
            <Button component={Link} to="/schedule" color="inherit">
              Schedule
            </Button>
            <Button component={Link} to="/accommodation" color="inherit">
              Accommodation
            </Button>
            <Button component={Link} to="/location" color="inherit">
              Location
            </Button>
            <Button component={Link} to="/thingstodo" color="inherit">
              Things to do
            </Button>
            <Button component={Link} to="/registry" color="inherit">
              Registry
            </Button>
            <Button component={Link} to="/faq" color="inherit">
              FAQ
            </Button>
            <Button component={Link} to="/rsvp" color="inherit">
              RSVP
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={theme.mixins.toolbar} />
      <Box sx={{ paddingTop: "5rem" }} />
    </>
  );
}
